import * as L from "react";
import ct from "react";
import { s as U, b as ut } from "./styled-38387a7e.js";
import { a as rt, g as Nt, u as Rt, c as wt } from "./useThemeProps-ee4acb93.js";
import { _ as c, g as _t, p as t, c as Y, l as Et, e as Vt, b as at, a as It } from "./createTheme-02ce03eb.js";
import { c as ce, j as N } from "./useTheme-efe1290c.js";
import { u as Mt } from "./useTheme-d46e2483.js";
import { i as Re, u as H } from "./useSlotProps-5893c531.js";
import { u as At } from "./useControlled-cc2d41cb.js";
import { u as zt } from "./useIsFocusVisible-4693b580.js";
import { a as jt, u as We } from "./useEventCallback-fe4fd69c.js";
import { o as we } from "./ownerDocument-5430cd5b.js";
import { c as nt } from "./chainPropTypes-004bf492.js";
import "@emotion/styled";
import "@emotion/react";
const Dt = {
  border: 0,
  clip: "rect(0 0 0 0)",
  height: "1px",
  margin: -1,
  overflow: "hidden",
  padding: 0,
  position: "absolute",
  whiteSpace: "nowrap",
  width: "1px"
}, Ft = Dt, Bt = 2;
function dt(e, o) {
  return e - o;
}
function ve(e, o, a) {
  return e == null ? o : Math.min(Math.max(o, e), a);
}
function lt(e, o) {
  var a;
  const {
    index: s
  } = (a = e.reduce((d, S, R) => {
    const f = Math.abs(o - S);
    return d === null || f < d.distance || f === d.distance ? {
      distance: f,
      index: R
    } : d;
  }, null)) != null ? a : {};
  return s;
}
function $e(e, o) {
  if (o.current !== void 0 && e.changedTouches) {
    const a = e;
    for (let s = 0; s < a.changedTouches.length; s += 1) {
      const d = a.changedTouches[s];
      if (d.identifier === o.current)
        return {
          x: d.clientX,
          y: d.clientY
        };
    }
    return !1;
  }
  return {
    x: e.clientX,
    y: e.clientY
  };
}
function _e(e, o, a) {
  return (e - o) * 100 / (a - o);
}
function Ht(e, o, a) {
  return (a - o) * e + o;
}
function Yt(e) {
  if (Math.abs(e) < 1) {
    const a = e.toExponential().split("e-"), s = a[0].split(".")[1];
    return (s ? s.length : 0) + parseInt(a[1], 10);
  }
  const o = e.toString().split(".")[1];
  return o ? o.length : 0;
}
function Ut(e, o, a) {
  const s = Math.round((e - a) / o) * o + a;
  return Number(s.toFixed(Yt(o)));
}
function st({
  values: e,
  newValue: o,
  index: a
}) {
  const s = e.slice();
  return s[a] = o, s.sort(dt);
}
function Oe({
  sliderRef: e,
  activeIndex: o,
  setActive: a
}) {
  var s, d;
  const S = we(e.current);
  if (!((s = e.current) != null && s.contains(S.activeElement)) || Number(S == null || (d = S.activeElement) == null ? void 0 : d.getAttribute("data-index")) !== o) {
    var R;
    (R = e.current) == null || R.querySelector(`[type="range"][data-index="${o}"]`).focus();
  }
  a && a(o);
}
const Xt = {
  horizontal: {
    offset: (e) => ({
      left: `${e}%`
    }),
    leap: (e) => ({
      width: `${e}%`
    })
  },
  "horizontal-reverse": {
    offset: (e) => ({
      right: `${e}%`
    }),
    leap: (e) => ({
      width: `${e}%`
    })
  },
  vertical: {
    offset: (e) => ({
      bottom: `${e}%`
    }),
    leap: (e) => ({
      height: `${e}%`
    })
  }
}, Wt = (e) => e;
let Ne;
function qe() {
  return Ne === void 0 && (typeof CSS < "u" && typeof CSS.supports == "function" ? Ne = CSS.supports("touch-action", "none") : Ne = !0), Ne;
}
function qt(e) {
  const {
    "aria-labelledby": o,
    defaultValue: a,
    disabled: s = !1,
    disableSwap: d = !1,
    isRtl: S = !1,
    marks: R = !1,
    max: f = 100,
    min: b = 0,
    name: X,
    onChange: ue,
    onChangeCommitted: W,
    orientation: te = "horizontal",
    ref: he,
    scale: de = Wt,
    step: _ = 1,
    tabIndex: ge,
    value: ye
  } = e, A = L.useRef(), [pe, D] = L.useState(-1), [ke, F] = L.useState(-1), [me, fe] = L.useState(!1), q = L.useRef(0), [G, B] = At({
    controlled: ye,
    default: a ?? b,
    name: "Slider"
  }), z = ue && ((r, n, l) => {
    const i = r.nativeEvent || r, x = new i.constructor(i.type, i);
    Object.defineProperty(x, "target", {
      writable: !0,
      value: {
        value: n,
        name: X
      }
    }), ue(x, n, l);
  }), J = Array.isArray(G);
  let y = J ? G.slice().sort(dt) : [G];
  y = y.map((r) => ve(r, b, f));
  const oe = R === !0 && _ !== null ? [...Array(Math.floor((f - b) / _) + 1)].map((r, n) => ({
    value: b + _ * n
  })) : R || [], E = oe.map((r) => r.value), {
    isFocusVisibleRef: xe,
    onBlur: V,
    onFocus: I,
    ref: Ee
  } = zt(), [Te, re] = L.useState(-1), P = L.useRef(), Le = rt(Ee, P), Se = rt(he, Le), Pe = (r) => (n) => {
    var l;
    const i = Number(n.currentTarget.getAttribute("data-index"));
    I(n), xe.current === !0 && re(i), F(i), r == null || (l = r.onFocus) == null || l.call(r, n);
  }, Ve = (r) => (n) => {
    var l;
    V(n), xe.current === !1 && re(-1), F(-1), r == null || (l = r.onBlur) == null || l.call(r, n);
  };
  jt(() => {
    if (s && P.current.contains(document.activeElement)) {
      var r;
      (r = document.activeElement) == null || r.blur();
    }
  }, [s]), s && pe !== -1 && D(-1), s && Te !== -1 && re(-1);
  const ae = (r) => (n) => {
    var l;
    (l = r.onChange) == null || l.call(r, n);
    const i = Number(n.currentTarget.getAttribute("data-index")), x = y[i], $ = E.indexOf(x);
    let m = n.target.valueAsNumber;
    if (oe && _ == null && (m = m < x ? E[$ - 1] : E[$ + 1]), m = ve(m, b, f), oe && _ == null) {
      const C = E.indexOf(y[i]);
      m = m < y[i] ? E[C - 1] : E[C + 1];
    }
    if (J) {
      d && (m = ve(m, y[i - 1] || -1 / 0, y[i + 1] || 1 / 0));
      const C = m;
      m = st({
        values: y,
        newValue: m,
        index: i
      });
      let u = i;
      d || (u = m.indexOf(C)), Oe({
        sliderRef: P,
        activeIndex: u
      });
    }
    B(m), re(i), z && z(n, m, i), W && W(n, m);
  }, K = L.useRef();
  let ne = te;
  S && te === "horizontal" && (ne += "-reverse");
  const le = ({
    finger: r,
    move: n = !1
  }) => {
    const {
      current: l
    } = P, {
      width: i,
      height: x,
      bottom: $,
      left: m
    } = l.getBoundingClientRect();
    let C;
    ne.indexOf("vertical") === 0 ? C = ($ - r.y) / x : C = (r.x - m) / i, ne.indexOf("-reverse") !== -1 && (C = 1 - C);
    let u;
    if (u = Ht(C, b, f), _)
      u = Ut(u, _, b);
    else {
      const be = lt(E, u);
      u = E[be];
    }
    u = ve(u, b, f);
    let M = 0;
    if (J) {
      n ? M = K.current : M = lt(y, u), d && (u = ve(u, y[M - 1] || -1 / 0, y[M + 1] || 1 / 0));
      const be = u;
      u = st({
        values: y,
        newValue: u,
        index: M
      }), d && n || (M = u.indexOf(be), K.current = M);
    }
    return {
      newValue: u,
      activeIndex: M
    };
  }, Q = We((r) => {
    const n = $e(r, A);
    if (!n)
      return;
    if (q.current += 1, r.type === "mousemove" && r.buttons === 0) {
      w(r);
      return;
    }
    const {
      newValue: l,
      activeIndex: i
    } = le({
      finger: n,
      move: !0
    });
    Oe({
      sliderRef: P,
      activeIndex: i,
      setActive: D
    }), B(l), !me && q.current > Bt && fe(!0), z && l !== G && z(r, l, i);
  }), w = We((r) => {
    const n = $e(r, A);
    if (fe(!1), !n)
      return;
    const {
      newValue: l
    } = le({
      finger: n,
      move: !0
    });
    D(-1), r.type === "touchend" && F(-1), W && W(r, l), A.current = void 0, p();
  }), v = We((r) => {
    if (s)
      return;
    qe() || r.preventDefault();
    const n = r.changedTouches[0];
    n != null && (A.current = n.identifier);
    const l = $e(r, A);
    if (l !== !1) {
      const {
        newValue: x,
        activeIndex: $
      } = le({
        finger: l
      });
      Oe({
        sliderRef: P,
        activeIndex: $,
        setActive: D
      }), B(x), z && z(r, x, $);
    }
    q.current = 0;
    const i = we(P.current);
    i.addEventListener("touchmove", Q), i.addEventListener("touchend", w);
  }), p = L.useCallback(() => {
    const r = we(P.current);
    r.removeEventListener("mousemove", Q), r.removeEventListener("mouseup", w), r.removeEventListener("touchmove", Q), r.removeEventListener("touchend", w);
  }, [w, Q]);
  L.useEffect(() => {
    const {
      current: r
    } = P;
    return r.addEventListener("touchstart", v, {
      passive: qe()
    }), () => {
      r.removeEventListener("touchstart", v, {
        passive: qe()
      }), p();
    };
  }, [p, v]), L.useEffect(() => {
    s && p();
  }, [s, p]);
  const se = (r) => (n) => {
    var l;
    if ((l = r.onMouseDown) == null || l.call(r, n), s || n.defaultPrevented || n.button !== 0)
      return;
    n.preventDefault();
    const i = $e(n, A);
    if (i !== !1) {
      const {
        newValue: $,
        activeIndex: m
      } = le({
        finger: i
      });
      Oe({
        sliderRef: P,
        activeIndex: m,
        setActive: D
      }), B($), z && z(n, $, m);
    }
    q.current = 0;
    const x = we(P.current);
    x.addEventListener("mousemove", Q), x.addEventListener("mouseup", w);
  }, Z = _e(J ? y[0] : b, b, f), ee = _e(y[y.length - 1], b, f) - Z, Ie = (r = {}) => {
    const n = {
      onMouseDown: se(r || {})
    }, l = c({}, r, n);
    return c({
      ref: Se
    }, l);
  }, T = (r) => (n) => {
    var l;
    (l = r.onMouseOver) == null || l.call(r, n);
    const i = Number(n.currentTarget.getAttribute("data-index"));
    F(i);
  }, ie = (r) => (n) => {
    var l;
    (l = r.onMouseLeave) == null || l.call(r, n), F(-1);
  };
  return {
    active: pe,
    axis: ne,
    axisProps: Xt,
    dragging: me,
    focusedThumbIndex: Te,
    getHiddenInputProps: (r = {}) => {
      var n;
      const l = {
        onChange: ae(r || {}),
        onFocus: Pe(r || {}),
        onBlur: Ve(r || {})
      }, i = c({}, r, l);
      return c({
        tabIndex: ge,
        "aria-labelledby": o,
        "aria-orientation": te,
        "aria-valuemax": de(f),
        "aria-valuemin": de(b),
        name: X,
        type: "range",
        min: e.min,
        max: e.max,
        step: (n = e.step) != null ? n : void 0,
        disabled: s
      }, i, {
        style: c({}, Ft, {
          direction: S ? "rtl" : "ltr",
          // So that VoiceOver's focus indicator matches the thumb's dimensions
          width: "100%",
          height: "100%"
        })
      });
    },
    getRootProps: Ie,
    getThumbProps: (r = {}) => {
      const n = {
        onMouseOver: T(r || {}),
        onMouseLeave: ie(r || {})
      };
      return c({}, r, n);
    },
    marks: oe,
    open: ke,
    range: J,
    trackLeap: ee,
    trackOffset: Z,
    values: y
  };
}
const Gt = (e) => !e || !Re(e), Jt = Gt;
function Kt(e) {
  return _t("MuiSlider", e);
}
const Qt = Nt("MuiSlider", ["root", "active", "colorPrimary", "colorSecondary", "disabled", "dragging", "focusVisible", "mark", "markActive", "marked", "markLabel", "markLabelActive", "rail", "sizeSmall", "thumb", "thumbColorPrimary", "thumbColorSecondary", "track", "trackInverted", "trackFalse", "thumbSizeSmall", "valueLabel", "valueLabelOpen", "valueLabelCircle", "valueLabelLabel", "vertical"]), g = Qt, Zt = (e) => {
  const {
    open: o
  } = e;
  return {
    offset: ce(o && g.valueLabelOpen),
    circle: g.valueLabelCircle,
    label: g.valueLabelLabel
  };
};
function pt(e) {
  const {
    children: o,
    className: a,
    value: s
  } = e, d = Zt(e);
  return o ? /* @__PURE__ */ L.cloneElement(o, {
    className: ce(o.props.className)
  }, /* @__PURE__ */ N.jsxs(L.Fragment, {
    children: [o.props.children, /* @__PURE__ */ N.jsx("span", {
      className: ce(d.offset, a),
      "aria-hidden": !0,
      children: /* @__PURE__ */ N.jsx("span", {
        className: d.circle,
        children: /* @__PURE__ */ N.jsx("span", {
          className: d.label,
          children: s
        })
      })
    })]
  })) : null;
}
process.env.NODE_ENV !== "production" && (pt.propTypes = {
  children: t.element.isRequired,
  className: t.string,
  value: t.node
});
const eo = ["aria-label", "aria-valuetext", "aria-labelledby", "component", "components", "componentsProps", "color", "classes", "className", "disableSwap", "disabled", "getAriaLabel", "getAriaValueText", "marks", "max", "min", "name", "onChange", "onChangeCommitted", "orientation", "size", "step", "scale", "slotProps", "slots", "tabIndex", "track", "value", "valueLabelDisplay", "valueLabelFormat"];
function it(e) {
  return e;
}
const mt = U("span", {
  name: "MuiSlider",
  slot: "Root",
  overridesResolver: (e, o) => {
    const {
      ownerState: a
    } = e;
    return [o.root, o[`color${Y(a.color)}`], a.size !== "medium" && o[`size${Y(a.size)}`], a.marked && o.marked, a.orientation === "vertical" && o.vertical, a.track === "inverted" && o.trackInverted, a.track === !1 && o.trackFalse];
  }
})(({
  theme: e,
  ownerState: o
}) => c({
  borderRadius: 12,
  boxSizing: "content-box",
  display: "inline-block",
  position: "relative",
  cursor: "pointer",
  touchAction: "none",
  color: (e.vars || e).palette[o.color].main,
  WebkitTapHighlightColor: "transparent"
}, o.orientation === "horizontal" && c({
  height: 4,
  width: "100%",
  padding: "13px 0",
  // The primary input mechanism of the device includes a pointing device of limited accuracy.
  "@media (pointer: coarse)": {
    // Reach 42px touch target, about ~8mm on screen.
    padding: "20px 0"
  }
}, o.size === "small" && {
  height: 2
}, o.marked && {
  marginBottom: 20
}), o.orientation === "vertical" && c({
  height: "100%",
  width: 4,
  padding: "0 13px",
  // The primary input mechanism of the device includes a pointing device of limited accuracy.
  "@media (pointer: coarse)": {
    // Reach 42px touch target, about ~8mm on screen.
    padding: "0 20px"
  }
}, o.size === "small" && {
  width: 2
}, o.marked && {
  marginRight: 44
}), {
  "@media print": {
    colorAdjust: "exact"
  },
  [`&.${g.disabled}`]: {
    pointerEvents: "none",
    cursor: "default",
    color: (e.vars || e).palette.grey[400]
  },
  [`&.${g.dragging}`]: {
    [`& .${g.thumb}, & .${g.track}`]: {
      transition: "none"
    }
  }
}));
process.env.NODE_ENV !== "production" && (mt.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------
  /**
   * @ignore
   */
  children: t.node
});
const ft = U("span", {
  name: "MuiSlider",
  slot: "Rail",
  overridesResolver: (e, o) => o.rail
})(({
  ownerState: e
}) => c({
  display: "block",
  position: "absolute",
  borderRadius: "inherit",
  backgroundColor: "currentColor",
  opacity: 0.38
}, e.orientation === "horizontal" && {
  width: "100%",
  height: "inherit",
  top: "50%",
  transform: "translateY(-50%)"
}, e.orientation === "vertical" && {
  height: "100%",
  width: "inherit",
  left: "50%",
  transform: "translateX(-50%)"
}, e.track === "inverted" && {
  opacity: 1
}));
process.env.NODE_ENV !== "production" && (ft.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------
  /**
   * @ignore
   */
  children: t.node
});
const bt = U("span", {
  name: "MuiSlider",
  slot: "Track",
  overridesResolver: (e, o) => o.track
})(({
  theme: e,
  ownerState: o
}) => {
  const a = (
    // Same logic as the LinearProgress track color
    e.palette.mode === "light" ? Et(e.palette[o.color].main, 0.62) : Vt(e.palette[o.color].main, 0.5)
  );
  return c({
    display: "block",
    position: "absolute",
    borderRadius: "inherit",
    border: "1px solid currentColor",
    backgroundColor: "currentColor",
    transition: e.transitions.create(["left", "width", "bottom", "height"], {
      duration: e.transitions.duration.shortest
    })
  }, o.size === "small" && {
    border: "none"
  }, o.orientation === "horizontal" && {
    height: "inherit",
    top: "50%",
    transform: "translateY(-50%)"
  }, o.orientation === "vertical" && {
    width: "inherit",
    left: "50%",
    transform: "translateX(-50%)"
  }, o.track === !1 && {
    display: "none"
  }, o.track === "inverted" && {
    backgroundColor: e.vars ? e.vars.palette.Slider[`${o.color}Track`] : a,
    borderColor: e.vars ? e.vars.palette.Slider[`${o.color}Track`] : a
  });
});
process.env.NODE_ENV !== "production" && (bt.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------
  /**
   * @ignore
   */
  children: t.node
});
const Ge = U("span", {
  name: "MuiSlider",
  slot: "Thumb",
  overridesResolver: (e, o) => {
    const {
      ownerState: a
    } = e;
    return [o.thumb, o[`thumbColor${Y(a.color)}`], a.size !== "medium" && o[`thumbSize${Y(a.size)}`]];
  }
})(({
  theme: e,
  ownerState: o
}) => c({
  position: "absolute",
  width: 20,
  height: 20,
  boxSizing: "border-box",
  borderRadius: "50%",
  outline: 0,
  backgroundColor: "currentColor",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  transition: e.transitions.create(["box-shadow", "left", "bottom"], {
    duration: e.transitions.duration.shortest
  })
}, o.size === "small" && {
  width: 12,
  height: 12
}, o.orientation === "horizontal" && {
  top: "50%",
  transform: "translate(-50%, -50%)"
}, o.orientation === "vertical" && {
  left: "50%",
  transform: "translate(-50%, 50%)"
}, {
  "&:before": c({
    position: "absolute",
    content: '""',
    borderRadius: "inherit",
    width: "100%",
    height: "100%",
    boxShadow: (e.vars || e).shadows[2]
  }, o.size === "small" && {
    boxShadow: "none"
  }),
  "&::after": {
    position: "absolute",
    content: '""',
    borderRadius: "50%",
    // 42px is the hit target
    width: 42,
    height: 42,
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)"
  },
  [`&:hover, &.${g.focusVisible}`]: {
    boxShadow: `0px 0px 0px 8px ${e.vars ? `rgba(${e.vars.palette[o.color].mainChannel} / 0.16)` : at(e.palette[o.color].main, 0.16)}`,
    "@media (hover: none)": {
      boxShadow: "none"
    }
  },
  [`&.${g.active}`]: {
    boxShadow: `0px 0px 0px 14px ${e.vars ? `rgba(${e.vars.palette[o.color].mainChannel} / 0.16)` : at(e.palette[o.color].main, 0.16)}`
  },
  [`&.${g.disabled}`]: {
    "&:hover": {
      boxShadow: "none"
    }
  }
}));
process.env.NODE_ENV !== "production" && (Ge.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------
  /**
   * @ignore
   */
  children: t.node
});
const vt = U(pt, {
  name: "MuiSlider",
  slot: "ValueLabel",
  overridesResolver: (e, o) => o.valueLabel
})(({
  theme: e,
  ownerState: o
}) => c({
  [`&.${g.valueLabelOpen}`]: {
    transform: "translateY(-100%) scale(1)"
  },
  zIndex: 1,
  whiteSpace: "nowrap"
}, e.typography.body2, {
  fontWeight: 500,
  transition: e.transitions.create(["transform"], {
    duration: e.transitions.duration.shortest
  }),
  transform: "translateY(-100%) scale(0)",
  position: "absolute",
  backgroundColor: (e.vars || e).palette.grey[600],
  borderRadius: 2,
  color: (e.vars || e).palette.common.white,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  padding: "0.25rem 0.75rem"
}, o.orientation === "horizontal" && {
  top: "-10px",
  transformOrigin: "bottom center",
  "&:before": {
    position: "absolute",
    content: '""',
    width: 8,
    height: 8,
    transform: "translate(-50%, 50%) rotate(45deg)",
    backgroundColor: "inherit",
    bottom: 0,
    left: "50%"
  }
}, o.orientation === "vertical" && {
  right: "30px",
  top: "24px",
  transformOrigin: "right center",
  "&:before": {
    position: "absolute",
    content: '""',
    width: 8,
    height: 8,
    transform: "translate(-50%, 50%) rotate(45deg)",
    backgroundColor: "inherit",
    right: "-20%",
    top: "25%"
  }
}, o.size === "small" && {
  fontSize: e.typography.pxToRem(12),
  padding: "0.25rem 0.5rem"
}));
process.env.NODE_ENV !== "production" && (vt.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------
  /**
   * @ignore
   */
  children: t.node
});
const ht = U("span", {
  name: "MuiSlider",
  slot: "Mark",
  shouldForwardProp: (e) => ut(e) && e !== "markActive",
  overridesResolver: (e, o) => {
    const {
      markActive: a
    } = e;
    return [o.mark, a && o.markActive];
  }
})(({
  theme: e,
  ownerState: o,
  markActive: a
}) => c({
  position: "absolute",
  width: 2,
  height: 2,
  borderRadius: 1,
  backgroundColor: "currentColor"
}, o.orientation === "horizontal" && {
  top: "50%",
  transform: "translate(-1px, -50%)"
}, o.orientation === "vertical" && {
  left: "50%",
  transform: "translate(-50%, 1px)"
}, a && {
  backgroundColor: (e.vars || e).palette.background.paper,
  opacity: 0.8
}));
process.env.NODE_ENV !== "production" && (ht.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------
  /**
   * @ignore
   */
  children: t.node
});
const gt = U("span", {
  name: "MuiSlider",
  slot: "MarkLabel",
  shouldForwardProp: (e) => ut(e) && e !== "markLabelActive",
  overridesResolver: (e, o) => o.markLabel
})(({
  theme: e,
  ownerState: o,
  markLabelActive: a
}) => c({}, e.typography.body2, {
  color: (e.vars || e).palette.text.secondary,
  position: "absolute",
  whiteSpace: "nowrap"
}, o.orientation === "horizontal" && {
  top: 30,
  transform: "translateX(-50%)",
  "@media (pointer: coarse)": {
    top: 40
  }
}, o.orientation === "vertical" && {
  left: 36,
  transform: "translateY(50%)",
  "@media (pointer: coarse)": {
    left: 44
  }
}, a && {
  color: (e.vars || e).palette.text.primary
}));
process.env.NODE_ENV !== "production" && (gt.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------
  /**
   * @ignore
   */
  children: t.node
});
const to = (e) => {
  const {
    disabled: o,
    dragging: a,
    marked: s,
    orientation: d,
    track: S,
    classes: R,
    color: f,
    size: b
  } = e, X = {
    root: ["root", o && "disabled", a && "dragging", s && "marked", d === "vertical" && "vertical", S === "inverted" && "trackInverted", S === !1 && "trackFalse", f && `color${Y(f)}`, b && `size${Y(b)}`],
    rail: ["rail"],
    track: ["track"],
    mark: ["mark"],
    markActive: ["markActive"],
    markLabel: ["markLabel"],
    markLabelActive: ["markLabelActive"],
    valueLabel: ["valueLabel"],
    thumb: ["thumb", o && "disabled", b && `thumbSize${Y(b)}`, f && `thumbColor${Y(f)}`],
    active: ["active"],
    disabled: ["disabled"],
    focusVisible: ["focusVisible"]
  };
  return wt(X, Kt, R);
}, oo = ({
  children: e
}) => e, yt = /* @__PURE__ */ L.forwardRef(function(o, a) {
  var s, d, S, R, f, b, X, ue, W, te, he, de, _, ge, ye, A, pe, D, ke, F, me, fe, q, G;
  const B = Rt({
    props: o,
    name: "MuiSlider"
  }), J = Mt().direction === "rtl", {
    "aria-label": y,
    "aria-valuetext": oe,
    "aria-labelledby": E,
    // eslint-disable-next-line react/prop-types
    component: xe = "span",
    components: V = {},
    componentsProps: I = {},
    color: Ee = "primary",
    classes: Te,
    className: re,
    disableSwap: P = !1,
    disabled: Le = !1,
    getAriaLabel: Se,
    getAriaValueText: Pe,
    marks: Ve = !1,
    max: ae = 100,
    min: K = 0,
    orientation: ne = "horizontal",
    size: le = "medium",
    step: Q = 1,
    scale: w = it,
    slotProps: v,
    slots: p,
    track: se = "normal",
    valueLabelDisplay: Z = "off",
    valueLabelFormat: ee = it
  } = B, Ie = It(B, eo), T = c({}, B, {
    isRtl: J,
    max: ae,
    min: K,
    classes: Te,
    disabled: Le,
    disableSwap: P,
    orientation: ne,
    marks: Ve,
    color: Ee,
    size: le,
    step: Q,
    scale: w,
    track: se,
    valueLabelDisplay: Z,
    valueLabelFormat: ee
  }), {
    axisProps: ie,
    getRootProps: Je,
    getHiddenInputProps: Ke,
    getThumbProps: r,
    open: n,
    active: l,
    axis: i,
    focusedThumbIndex: x,
    range: $,
    dragging: m,
    marks: C,
    values: u,
    trackOffset: M,
    trackLeap: be
  } = qt(c({}, T, {
    ref: a
  }));
  T.marked = C.length > 0 && C.some((h) => h.label), T.dragging = m, T.focusedThumbIndex = x;
  const O = to(T), Me = (s = (d = p == null ? void 0 : p.root) != null ? d : V.Root) != null ? s : mt, Qe = (S = (R = p == null ? void 0 : p.rail) != null ? R : V.Rail) != null ? S : ft, Ze = (f = (b = p == null ? void 0 : p.track) != null ? b : V.Track) != null ? f : bt, et = (X = (ue = p == null ? void 0 : p.thumb) != null ? ue : V.Thumb) != null ? X : Ge, tt = (W = (te = p == null ? void 0 : p.valueLabel) != null ? te : V.ValueLabel) != null ? W : vt, Ae = (he = (de = p == null ? void 0 : p.mark) != null ? de : V.Mark) != null ? he : ht, ze = (_ = (ge = p == null ? void 0 : p.markLabel) != null ? ge : V.MarkLabel) != null ? _ : gt, ot = (ye = (A = p == null ? void 0 : p.input) != null ? A : V.Input) != null ? ye : "input", je = (pe = v == null ? void 0 : v.root) != null ? pe : I.root, kt = (D = v == null ? void 0 : v.rail) != null ? D : I.rail, De = (ke = v == null ? void 0 : v.track) != null ? ke : I.track, Fe = (F = v == null ? void 0 : v.thumb) != null ? F : I.thumb, Be = (me = v == null ? void 0 : v.valueLabel) != null ? me : I.valueLabel, xt = (fe = v == null ? void 0 : v.mark) != null ? fe : I.mark, Tt = (q = v == null ? void 0 : v.markLabel) != null ? q : I.markLabel, Lt = (G = v == null ? void 0 : v.input) != null ? G : I.input, St = H({
    elementType: Me,
    getSlotProps: Je,
    externalSlotProps: je,
    externalForwardedProps: Ie,
    additionalProps: c({}, Jt(Me) && {
      as: xe
    }),
    ownerState: c({}, T, je == null ? void 0 : je.ownerState),
    className: [O.root, re]
  }), Pt = H({
    elementType: Qe,
    externalSlotProps: kt,
    ownerState: T,
    className: O.rail
  }), Ct = H({
    elementType: Ze,
    externalSlotProps: De,
    additionalProps: {
      style: c({}, ie[i].offset(M), ie[i].leap(be))
    },
    ownerState: c({}, T, De == null ? void 0 : De.ownerState),
    className: O.track
  }), He = H({
    elementType: et,
    getSlotProps: r,
    externalSlotProps: Fe,
    ownerState: c({}, T, Fe == null ? void 0 : Fe.ownerState),
    className: O.thumb
  }), $t = H({
    elementType: tt,
    externalSlotProps: Be,
    ownerState: c({}, T, Be == null ? void 0 : Be.ownerState),
    className: O.valueLabel
  }), Ye = H({
    elementType: Ae,
    externalSlotProps: xt,
    ownerState: T,
    className: O.mark
  }), Ue = H({
    elementType: ze,
    externalSlotProps: Tt,
    ownerState: T,
    className: O.markLabel
  }), Ot = H({
    elementType: ot,
    getSlotProps: Ke,
    externalSlotProps: Lt,
    ownerState: T
  });
  return /* @__PURE__ */ N.jsxs(Me, c({}, St, {
    children: [/* @__PURE__ */ N.jsx(Qe, c({}, Pt)), /* @__PURE__ */ N.jsx(Ze, c({}, Ct)), C.filter((h) => h.value >= K && h.value <= ae).map((h, k) => {
      const Xe = _e(h.value, K, ae), Ce = ie[i].offset(Xe);
      let j;
      return se === !1 ? j = u.indexOf(h.value) !== -1 : j = se === "normal" && ($ ? h.value >= u[0] && h.value <= u[u.length - 1] : h.value <= u[0]) || se === "inverted" && ($ ? h.value <= u[0] || h.value >= u[u.length - 1] : h.value >= u[0]), /* @__PURE__ */ N.jsxs(L.Fragment, {
        children: [/* @__PURE__ */ N.jsx(Ae, c({
          "data-index": k
        }, Ye, !Re(Ae) && {
          markActive: j
        }, {
          style: c({}, Ce, Ye.style),
          className: ce(Ye.className, j && O.markActive)
        })), h.label != null ? /* @__PURE__ */ N.jsx(ze, c({
          "aria-hidden": !0,
          "data-index": k
        }, Ue, !Re(ze) && {
          markLabelActive: j
        }, {
          style: c({}, Ce, Ue.style),
          className: ce(O.markLabel, Ue.className, j && O.markLabelActive),
          children: h.label
        })) : null]
      }, k);
    }), u.map((h, k) => {
      const Xe = _e(h, K, ae), Ce = ie[i].offset(Xe), j = Z === "off" ? oo : tt;
      return (
        /* TODO v6: Change component structure. It will help in avoiding the complicated React.cloneElement API added in SliderValueLabel component. Should be: Thumb -> Input, ValueLabel. Follow Joy UI's Slider structure. */
        /* @__PURE__ */ N.jsx(j, c({}, !Re(j) && {
          valueLabelFormat: ee,
          valueLabelDisplay: Z,
          value: typeof ee == "function" ? ee(w(h), k) : ee,
          index: k,
          open: n === k || l === k || Z === "on",
          disabled: Le
        }, $t, {
          children: /* @__PURE__ */ N.jsx(et, c({
            "data-index": k
          }, He, {
            className: ce(O.thumb, He.className, l === k && O.active, x === k && O.focusVisible),
            style: c({}, Ce, {
              pointerEvents: P && l !== k ? "none" : void 0
            }, He.style),
            children: /* @__PURE__ */ N.jsx(ot, c({
              "data-index": k,
              "aria-label": Se ? Se(k) : y,
              "aria-valuenow": w(h),
              "aria-labelledby": E,
              "aria-valuetext": Pe ? Pe(w(h), k) : oe,
              value: u[k]
            }, Ot))
          }))
        }), k)
      );
    })]
  }));
});
process.env.NODE_ENV !== "production" && (yt.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------
  /**
   * The label of the slider.
   */
  "aria-label": nt(t.string, (e) => Array.isArray(e.value || e.defaultValue) && e["aria-label"] != null ? new Error("MUI: You need to use the `getAriaLabel` prop instead of `aria-label` when using a range slider.") : null),
  /**
   * The id of the element containing a label for the slider.
   */
  "aria-labelledby": t.string,
  /**
   * A string value that provides a user-friendly name for the current value of the slider.
   */
  "aria-valuetext": nt(t.string, (e) => Array.isArray(e.value || e.defaultValue) && e["aria-valuetext"] != null ? new Error("MUI: You need to use the `getAriaValueText` prop instead of `aria-valuetext` when using a range slider.") : null),
  /**
   * @ignore
   */
  children: t.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: t.object,
  /**
   * @ignore
   */
  className: t.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#adding-new-colors).
   * @default 'primary'
   */
  color: t.oneOfType([t.oneOf(["primary", "secondary"]), t.string]),
  /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `slots` prop.
   * It's recommended to use the `slots` prop instead.
   *
   * @default {}
   */
  components: t.shape({
    Input: t.elementType,
    Mark: t.elementType,
    MarkLabel: t.elementType,
    Rail: t.elementType,
    Root: t.elementType,
    Thumb: t.elementType,
    Track: t.elementType,
    ValueLabel: t.elementType
  }),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * This prop is an alias for the `slotProps` prop.
   * It's recommended to use the `slotProps` prop instead, as `componentsProps` will be deprecated in the future.
   *
   * @default {}
   */
  componentsProps: t.shape({
    input: t.oneOfType([t.func, t.object]),
    mark: t.oneOfType([t.func, t.object]),
    markLabel: t.oneOfType([t.func, t.object]),
    rail: t.oneOfType([t.func, t.object]),
    root: t.oneOfType([t.func, t.object]),
    thumb: t.oneOfType([t.func, t.object]),
    track: t.oneOfType([t.func, t.object]),
    valueLabel: t.oneOfType([t.func, t.shape({
      children: t.element,
      className: t.string,
      open: t.bool,
      style: t.object,
      value: t.number,
      valueLabelDisplay: t.oneOf(["auto", "off", "on"])
    })])
  }),
  /**
   * The default value. Use when the component is not controlled.
   */
  defaultValue: t.oneOfType([t.arrayOf(t.number), t.number]),
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: t.bool,
  /**
   * If `true`, the active thumb doesn't swap when moving pointer over a thumb while dragging another thumb.
   * @default false
   */
  disableSwap: t.bool,
  /**
   * Accepts a function which returns a string value that provides a user-friendly name for the thumb labels of the slider.
   * This is important for screen reader users.
   * @param {number} index The thumb label's index to format.
   * @returns {string}
   */
  getAriaLabel: t.func,
  /**
   * Accepts a function which returns a string value that provides a user-friendly name for the current value of the slider.
   * This is important for screen reader users.
   * @param {number} value The thumb label's value to format.
   * @param {number} index The thumb label's index to format.
   * @returns {string}
   */
  getAriaValueText: t.func,
  /**
   * Marks indicate predetermined values to which the user can move the slider.
   * If `true` the marks are spaced according the value of the `step` prop.
   * If an array, it should contain objects with `value` and an optional `label` keys.
   * @default false
   */
  marks: t.oneOfType([t.arrayOf(t.shape({
    label: t.node,
    value: t.number.isRequired
  })), t.bool]),
  /**
   * The maximum allowed value of the slider.
   * Should not be equal to min.
   * @default 100
   */
  max: t.number,
  /**
   * The minimum allowed value of the slider.
   * Should not be equal to max.
   * @default 0
   */
  min: t.number,
  /**
   * Name attribute of the hidden `input` element.
   */
  name: t.string,
  /**
   * Callback function that is fired when the slider's value changed.
   *
   * @param {Event} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (any).
   * **Warning**: This is a generic event not a change event.
   * @param {number | number[]} value The new value.
   * @param {number} activeThumb Index of the currently moved thumb.
   */
  onChange: t.func,
  /**
   * Callback function that is fired when the `mouseup` is triggered.
   *
   * @param {React.SyntheticEvent | Event} event The event source of the callback. **Warning**: This is a generic event not a change event.
   * @param {number | number[]} value The new value.
   */
  onChangeCommitted: t.func,
  /**
   * The component orientation.
   * @default 'horizontal'
   */
  orientation: t.oneOf(["horizontal", "vertical"]),
  /**
   * A transformation function, to change the scale of the slider.
   * @param {any} x
   * @returns {any}
   * @default function Identity(x) {
   *   return x;
   * }
   */
  scale: t.func,
  /**
   * The size of the slider.
   * @default 'medium'
   */
  size: t.oneOfType([t.oneOf(["small", "medium"]), t.string]),
  /**
   * The props used for each slot inside the Slider.
   * @default {}
   */
  slotProps: t.shape({
    input: t.oneOfType([t.func, t.object]),
    mark: t.oneOfType([t.func, t.object]),
    markLabel: t.oneOfType([t.func, t.object]),
    rail: t.oneOfType([t.func, t.object]),
    root: t.oneOfType([t.func, t.object]),
    thumb: t.oneOfType([t.func, t.object]),
    track: t.oneOfType([t.func, t.object]),
    valueLabel: t.oneOfType([t.func, t.shape({
      children: t.element,
      className: t.string,
      open: t.bool,
      style: t.object,
      value: t.number,
      valueLabelDisplay: t.oneOf(["auto", "off", "on"])
    })])
  }),
  /**
   * The components used for each slot inside the Slider.
   * Either a string to use a HTML element or a component.
   * @default {}
   */
  slots: t.shape({
    input: t.elementType,
    mark: t.elementType,
    markLabel: t.elementType,
    rail: t.elementType,
    root: t.elementType,
    thumb: t.elementType,
    track: t.elementType,
    valueLabel: t.elementType
  }),
  /**
   * The granularity with which the slider can step through values. (A "discrete" slider.)
   * The `min` prop serves as the origin for the valid values.
   * We recommend (max - min) to be evenly divisible by the step.
   *
   * When step is `null`, the thumb can only be slid onto marks provided with the `marks` prop.
   * @default 1
   */
  step: t.number,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: t.oneOfType([t.arrayOf(t.oneOfType([t.func, t.object, t.bool])), t.func, t.object]),
  /**
   * Tab index attribute of the hidden `input` element.
   */
  tabIndex: t.number,
  /**
   * The track presentation:
   *
   * - `normal` the track will render a bar representing the slider value.
   * - `inverted` the track will render a bar representing the remaining slider value.
   * - `false` the track will render without a bar.
   * @default 'normal'
   */
  track: t.oneOf(["inverted", "normal", !1]),
  /**
   * The value of the slider.
   * For ranged sliders, provide an array with two values.
   */
  value: t.oneOfType([t.arrayOf(t.number), t.number]),
  /**
   * Controls when the value label is displayed:
   *
   * - `auto` the value label will display when the thumb is hovered or focused.
   * - `on` will display persistently.
   * - `off` will never display.
   * @default 'off'
   */
  valueLabelDisplay: t.oneOf(["auto", "off", "on"]),
  /**
   * The format function the value label's value.
   *
   * When a function is provided, it should have the following signature:
   *
   * - {number} value The value label's value to format
   * - {number} index The value label's index to format
   * @param {any} x
   * @returns {any}
   * @default function Identity(x) {
   *   return x;
   * }
   */
  valueLabelFormat: t.oneOfType([t.func, t.string])
});
const ro = yt, xo = U(
  no
)(({ theme: e, variant: o }) => ({
  color: e.palette.lightBlue.c100,
  cursor: "grab",
  height: 4,
  [`.${g.track}`]: {
    border: "none",
    backgroundColor: e.palette.blue.c20
  },
  [`.${g.thumb}`]: {
    backgroundColor: e.palette.lightBlue.c100,
    boxShadow: "none !important",
    //temporary workaround. Please do not use !important anywhere else. TODO: remove !important.,
    ...o === "v2" && {
      width: "2.5px",
      height: "55px",
      borderRadius: 0,
      transform: "translate(-50%, -80%)"
    }
  },
  [`.${g.rail}`]: {
    // backgroundColor: theme.palette.blue.c20,
    opacity: "unset"
  },
  [`.${g.markLabel}`]: {
    color: e.palette.lightBlue.c100
  },
  [`.${g.mark}`]: {
    backgroundColor: "transparent"
  },
  [`.${g.valueLabel}`]: {
    borderRadius: "30px",
    fontSize: "12px",
    fontWeight: 400,
    lineHeight: "16px",
    backgroundColor: e.palette.lightBlue.c10,
    color: e.palette.lightBlue.c100,
    ...o === "v2" && {
      backgroundColor: e.palette.lightBlue.c100,
      color: e.palette.common.white,
      width: "81px",
      height: "20px"
    },
    "&:before": {
      content: "none"
    }
  },
  ".first-thumb": {
    [`.${g.valueLabel}`]: {
      ...o === "v2" && {
        top: "59px",
        left: "-104px",
        borderTopRightRadius: 0,
        borderBottomRightRadius: 0,
        transform: "translate(1%, -210%)"
      }
    }
  },
  ".second-thumb": {
    [`.${g.valueLabel}`]: {
      ...o === "v2" && {
        top: "59px",
        left: "4px",
        borderTopLeftRadius: 0,
        borderBottomLeftRadius: 0,
        transform: "translate(-2%, -210%)"
      }
    }
  }
}));
function ao(e) {
  const { children: o, className: a, ...s } = e, d = s["data-index"] === 0 ? "first-thumb" : "second-thumb";
  return /* @__PURE__ */ ct.createElement(Ge, { ...s, className: `${a} ${d}` }, o);
}
function no(e) {
  return /* @__PURE__ */ ct.createElement(ro, { slots: { thumb: ao }, valueLabelDisplay: "on", ...e });
}
export {
  xo as default
};
